import { TGetOrganizationDto } from "@/api/services/main/organization/dtos/get-organization.dto";
import { TUpdateOrganizationReqDto } from "@/api/services/main/organization/dtos/update-organization.dto";
import { TOrganizationForm } from "@/features/organization/types/OrganizationForm";
import { convertNumberToZipCode, convertZipCodeToNumber } from "@/utils/input";

export const convertOrganizationToFormData = (data?: TGetOrganizationDto): TOrganizationForm => {
  return {
    name: data?.name ?? "",
    zipCode: data?.postalCode ? convertNumberToZipCode(data.postalCode) : null,
    province: data?.province ?? null,
    municipality: data?.municipality ?? null,
    addressLine: data?.addressLine ?? null,
    phone: data?.phone ?? null,
    // Show the "T" prefix only when the stored value is empty; otherwise show the stored value.
    invoiceRegistrationNumber: data?.invoiceRegistrationNumber || "T",
    bankAccount: data?.bankAccount ?? "",
  };
};

export const convertFormDataToReqDto = (form: TOrganizationForm): TUpdateOrganizationReqDto => {
  return {
    name: form.name,
    postalCode: form.zipCode ? convertZipCodeToNumber(form.zipCode) ?? null : null,
    province: form.province || null,
    municipality: form.municipality || null,
    addressLine: form.addressLine || null,
    phone: form.phone || null,
    // A bare "T" is just the untouched input prefix — persist it as null.
    invoiceRegistrationNumber: form.invoiceRegistrationNumber?.trim() && form.invoiceRegistrationNumber.trim() !== "T" ? form.invoiceRegistrationNumber : null,
    bankAccount: form.bankAccount || null,
  };
};
